import React, { memo } from 'react';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import {
  BigThingsColumns,
  BigThingsColumn,
  BigThingsAssetColumn,
  BigThingsTitle,
  BigThingsBody,
  BigThingsCloudImage,
} from './FindYourJoy.styles';
import { useTranslation } from 'react-i18next';

export const FindYourJoyContent: React.FC<{ id: string }> = memo(({ id }) => {
  const { t } = useTranslation('careers');
  const findYourJoyData = t('findYourJoy');
  return (
    <BigThingsColumns marginTop={11}>
      <BigThingsAssetColumn width={5}>
        <BigThingsCloudImage src="careers/find-your-joy/pic2-v2.jpg" />
      </BigThingsAssetColumn>
      <BigThingsColumn width={7}>
        <BigThingsTitle color="neutra6" variant="calloutHed32" tagName="h2">
          {findYourJoyData.bigThings.title}
        </BigThingsTitle>
        <BigThingsBody color="neutra5" variant="dek24" tagName="h3">
          {findYourJoyData.bigThings.body}
        </BigThingsBody>
        <Box marginTop={5}>
          <CTALink id={`${id}ReadOurFoundingStory`} href="/our-story" typography={'featureHed17'} hasChevron>
            {findYourJoyData.bigThings.cta}
          </CTALink>
        </Box>
      </BigThingsColumn>
    </BigThingsColumns>
  );
});
